
import { createClient } from '@supabase/supabase-js';

const supabaseUrl = (import.meta as any).env?.VITE_SUPABASE_URL || 'https://nhxikgbfqbnevzvxrxzr.supabase.co';
const supabaseAnonKey = (import.meta as any).env?.VITE_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im5oeGlrZ2JmcWJuZXZ6dnhyeHpyIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Njc4NDY4OTgsImV4cCI6MjA4MzQyMjg5OH0.1LWuSZQa8tBQuTSDgw5vR0V0z29ANRBKzZxAnVaiUo0';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

/**
 * Robustly extracts a readable error message from Supabase, Auth, or Function errors.
 */
export const getErrorMessage = (err: any): string => {
  if (!err) return 'An unknown connection error occurred (Status: null)';
  
  // 1. Check if it's already a string
  if (typeof err === 'string') return err;

  // 2. Handle standard JavaScript Error objects
  if (err instanceof Error) {
    if (err.message.includes('Failed to fetch') || err.message.includes('NetworkError')) {
      return 'Request Blocked: Ensure Ad-Blockers/Brave Shields are OFF for this domain.';
    }
    return err.message;
  }

  // 3. Handle Supabase Function Errors with Status Codes
  if (err.name === 'FunctionsHttpError') {
    return `HTTP ${err.status}: ${err.message || 'The server returned an error.'}`;
  }
  if (err.name === 'FunctionsRelayError') {
    return `Deployment Error: The Edge Function might not be deployed yet.`;
  }
  if (err.name === 'FunctionsFetchError') {
    return `Network Error: The request was aborted or blocked by the browser.`;
  }

  // 4. Handle Postgrest/Auth error objects
  if (err.message && typeof err.message === 'string') {
    return err.message;
  }

  // 5. Deep scan for nested error messages
  const nestedMsg = err.error?.message || err.error_description || err.error || err.context?.message;
  if (nestedMsg && typeof nestedMsg === 'string') return nestedMsg;

  // 6. Fallback: Stringify the whole object if possible
  try {
    const stringified = JSON.stringify(err);
    return stringified === '{}' ? String(err) : stringified;
  } catch {
    return String(err);
  }
};

export const toSnakeCase = (obj: any): any => {
  // Fix: Convert empty strings to null. Postgres UUID columns reject "" but accept NULL.
  if (obj === '') return null;
  
  if (Array.isArray(obj)) return obj.map(v => toSnakeCase(v));
  if (obj !== null && typeof obj === 'object' && obj.constructor === Object) {
    return Object.keys(obj).reduce((result, key) => ({
      ...result,
      [key.replace(/[A-Z]/g, letter => `_${letter.toLowerCase()}`)]: toSnakeCase(obj[key]),
    }), {});
  }
  return obj;
};

export const toCamelCase = (obj: any): any => {
  if (Array.isArray(obj)) return obj.map(v => toCamelCase(v));
  if (obj !== null && typeof obj === 'object' && obj.constructor === Object) {
    return Object.keys(obj).reduce((result, key) => ({
      ...result,
      [key.replace(/(_\w)/g, m => m[1].toUpperCase())]: toCamelCase(obj[key]),
    }), {});
  }
  return obj;
};
